import './show-error-modal.css';
import { renderConfirmModals } from '../confirm-modal/confirm-modals.jsx';
import { headNavBack } from '../../lib/utils';
import qs from "qs";

// eslint-disable-next-line
function show(text, history) {
    renderConfirmModals({
        title: text,
        closeText:'返回',
        confirmText: '加入课程',
        onClose: ()=> {
            if(history){
                headNavBack(history)
            }else{
                window.history.go(-1)
            }
        },
        onConfirm: () => {
            const query = qs.parse(history.location.search, { ignoreQueryPrefix: true });
            console.log(query.course_id)
            history.push(`/course?id=${query.course_id}`)
        }
    });
}

const errorModal = {
    show
};

window.showError = show;

export default errorModal;
